<template>
  <div :class="className">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Message',

  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: function (val) {
        return [
          'primary',
          'secondary',
          'success',
          'danger',
          'warning',
          'info'
        ].indexOf(val) !== -1
      }
    }
  },

  computed: {
    className() {
      return [this.$style.root, this.$style[this.variant]]
    }
  }
}
</script>

<style module>
.root {
  @apply rounded border border-l-4 p-4 bg-white;
}

.primary {
  @apply border-primary;
}

.secondary {
  @apply border-secondary;
}

.success {
  @apply border-success text-success;
}

.danger {
  @apply border-danger text-danger;
}

.warning {
  @apply border-warning text-warning;
}

.info {
  @apply border-dull text-dull-dark;
}
</style>
